import { createSelector } from 'reselect';

const selectMap = (s) => s.users.items;
const selectAddresses = (s) => s.users.addresses;
const selectDocuments = (s) => s.users.documents;
const selectProfileImages = (s) => s.users.profileImages;
const selectWatchlistInstruments = (s) => s.users.watchlistInstruments;
const selectWatchlists = (s) => s.users.watchlists;
const selectMeetings = (s) => s.users.meetings;
const selectCountries = (state) => state.statics.countries;
const selectDocumentTypes = (state) => state.statics.documentTypes;

export const selectUserId = (s) => s.app.user?.id;
export const selectWatchlistInstrumentsMap = (s, id) => s.users.watchlistInstrumentsMap[id];

export const selectUser = createSelector(
  (_, id) => id,
  selectMap,
  selectAddresses,
  selectDocuments,
  selectProfileImages,
  selectWatchlists,
  selectWatchlistInstruments,
  selectCountries,
  selectDocumentTypes,
  selectMeetings,
  (
    id,
    users,
    addresses,
    documents,
    profileImages,
    watchlists,
    watchlistInstruments,
    countries,
    documentTypes,
    meetings
  ) => {
    if (users[id]) {
      const user = { ...users[id] };
      user.addresses = addresses[id]?.map((a) => ({
        ...a,
        country: countries.find((c) => c.id === a.countryId) ?? {},
      }));
      user.documents = documents[id]?.map((d) => ({
        ...d,
        country: countries.find((c) => c.id === d.countryId) ?? {},
        documentType: documentTypes.find((dt) => dt.id === d.documentTypeId) ?? {},
      }));
      user.profileImage = profileImages[id];
      user.watchlists = watchlists[id];
      user.watchlistInstruments = watchlistInstruments[id];
      user.meetings = meetings[id];

      return user;
    }
    return undefined;
  }
);

export const selectUsers = (s) => Object.values(s.users.items);
